/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droprank1Inputs */

const en_droprank1 = /** @type {(inputs: Droprank1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rank`)
};

const de_droprank1 = /** @type {(inputs: Droprank1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rang`)
};

/**
* | output |
* | --- |
* | "Rank" |
*
* @param {Droprank1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droprank1 = /** @type {((inputs?: Droprank1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droprank1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droprank1(inputs)
	return de_droprank1(inputs)
});
export { droprank1 as "dropRank" }